// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar.inner-main-navbar {
  padding: 20px 30px !important;
  border-bottom: 0px !important;
  box-shadow: 0 16px 53px rgba(2, 58, 40, 0.08) !important;
  margin-bottom: 0;
  background-color: #fff !important;
}
.navbar.inner-main-navbar .user-dropdown .nav-link {
  display: flex;
  align-items: center;
  padding: 0px;
  margin: 0px;
  column-gap: 12px;
}
.navbar.inner-main-navbar .user-dropdown .nav-link .user-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ccc;
  border-radius: 50%;
}
.navbar.inner-main-navbar .user-dropdown .nav-link .user-icon .nc-icon {
  top: 0px;
  font-size: 18px;
  width: 18px;
}
.navbar.inner-main-navbar .user-dropdown .nav-link .user-details {
  color: rgb(2, 58, 40);
  display: flex;
  flex-direction: column;
}
.navbar.inner-main-navbar .user-dropdown .nav-link .user-details h3 {
  font-weight: 600;
  font-size: 18px;
  line-height: 26px;
  text-transform: capitalize;
  margin: 0px;
}
.navbar.inner-main-navbar .user-dropdown .nav-link .user-details span {
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  text-transform: capitalize;
}
.navbar.inner-main-navbar .user-dropdown .dropdown-menu {
  min-width: 100px;
  transform: translate3d(0px, 35px, 0px);
  padding: 6px;
  border-radius: 10px;
}
.navbar.inner-main-navbar .user-dropdown .dropdown-menu .dropdown-item {
  padding: 6px 12px;
  border-radius: 10px;
}
.navbar.inner-main-navbar .user-dropdown .dropdown-menu .dropdown-item:hover, .navbar.inner-main-navbar .user-dropdown .dropdown-menu .dropdown-item:focus {
  color: rgb(0, 58, 39) !important;
  background-color: rgba(2, 58, 40, 0.2);
}
.navbar.inner-main-navbar .logout-btn-wrap {
  border: 0;
  color: rgb(199, 16, 38);
  font-size: 18px;
  line-height: 26px;
  padding: 8px 14px;
  border-radius: 30px;
  background-color: rgba(193, 10, 10, 0.15);
  min-width: 140px;
  min-height: 50px;
}
.navbar.inner-main-navbar .logout-btn-wrap:hover, .navbar.inner-main-navbar .logout-btn-wrap:focus, .navbar.inner-main-navbar .logout-btn-wrap:active {
  background-color: rgba(193, 10, 10, 0.3) !important;
  color: rgb(199, 16, 38);
}
.navbar.inner-main-navbar .logout-btn-wrap .fa {
  font-size: 14px;
}
@media (max-width: 1600px) {
  .navbar.inner-main-navbar {
    padding: 15px 25px !important;
  }
  .navbar.inner-main-navbar .user-dropdown .nav-link .user-icon {
    width: 45px;
    height: 45px;
  }
  .navbar.inner-main-navbar .user-dropdown .nav-link .user-icon .nc-icon {
    font-size: 16px;
    width: 16px;
  }
  .navbar.inner-main-navbar .user-dropdown .nav-link .user-details h3 {
    font-size: 16px;
    line-height: 24px;
  }
  .navbar.inner-main-navbar .user-dropdown .nav-link .user-details span {
    font-size: 14px;
    line-height: 20px;
  }
  .navbar.inner-main-navbar .logout-btn-wrap {
    font-size: 16px;
    line-height: 24px;
    padding: 6px 12px;
    min-width: 125px;
    min-height: 42px;
  }
  .navbar .navbar-brand {
    width: 220px;
  }
}
@media (max-width: 1399px) {
  .navbar.inner-main-navbar {
    padding: 10px 25px !important;
  }
  .navbar.inner-main-navbar .user-dropdown .nav-link {
    column-gap: 10px;
  }
  .navbar.inner-main-navbar .user-dropdown .nav-link .user-icon {
    width: 36px;
    height: 36px;
  }
  .navbar.inner-main-navbar .user-dropdown .nav-link .user-icon .nc-icon {
    font-size: 12px;
    width: 12px;
  }
  .navbar.inner-main-navbar .user-dropdown .nav-link .user-details h3 {
    font-size: 14px;
    line-height: 20px;
  }
  .navbar.inner-main-navbar .user-dropdown .nav-link .user-details span {
    font-size: 12px;
    line-height: 16px;
  }
  .navbar.inner-main-navbar .logout-btn-wrap {
    font-size: 14px;
    line-height: 22px;
    padding: 4px 10px;
    min-width: 100px;
    min-height: 35px;
  }
  .navbar .navbar-brand {
    width: 180px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Navbars/DemoNavbar.scss"],"names":[],"mappings":"AACI;EACI,6BAAA;EACA,6BAAA;EACA,wDAAA;EACA,gBAAA;EACA,iCAAA;AAAR;AAGY;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AADhB;AAEgB;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AAApB;AACoB;EACI,QAAA;EACA,eAAA;EACA,WAAA;AACxB;AAEgB;EACI,qBAAA;EACA,aAAA;EACA,sBAAA;AAApB;AACoB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,WAAA;AACxB;AACoB;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;AACxB;AAGY;EACI,gBAAA;EACA,sCAAA;EACA,YAAA;EACA,mBAAA;AADhB;AAEgB;EACI,iBAAA;EACA,mBAAA;AAApB;AACoB;EAEI,gCAAA;EACA,sCAAA;AAAxB;AAKQ;EACI,SAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,gBAAA;AAHZ;AAIY;EAGI,mDAAA;EACA,uBAAA;AAJhB;AAMY;EACI,eAAA;AAJhB;AAQI;EACI;IACI,6BAAA;EANV;EASkB;IACI,WAAA;IACA,YAAA;EAPtB;EAQsB;IACI,eAAA;IACA,WAAA;EAN1B;EAUsB;IACI,eAAA;IACA,iBAAA;EAR1B;EAUsB;IACI,eAAA;IACA,iBAAA;EAR1B;EAaU;IACI,eAAA;IACA,iBAAA;IACA,iBAAA;IACA,gBAAA;IACA,gBAAA;EAXd;EAcM;IACI,YAAA;EAZV;AACF;AAcI;EACI;IACI,6BAAA;EAZV;EAcc;IACI,gBAAA;EAZlB;EAakB;IACI,WAAA;IACA,YAAA;EAXtB;EAYsB;IACI,eAAA;IACA,WAAA;EAV1B;EAcsB;IACI,eAAA;IACA,iBAAA;EAZ1B;EAcsB;IACI,eAAA;IACA,iBAAA;EAZ1B;EAiBU;IACI,eAAA;IACA,iBAAA;IACA,iBAAA;IACA,gBAAA;IACA,gBAAA;EAfd;EAkBM;IACI,YAAA;EAhBV;AACF","sourcesContent":[".navbar{\n    &.inner-main-navbar{\n        padding: 20px 30px !important;\n        border-bottom: 0px !important;\n        box-shadow: 0 16px 53px rgba(2, 58, 40, 0.08) !important;\n        margin-bottom: 0;\n        background-color: #fff !important;\n        \n        .user-dropdown{\n            .nav-link{\n                display: flex;\n                align-items: center;\n                padding: 0px;\n                margin: 0px;\n                column-gap: 12px;\n                .user-icon{\n                    width: 50px;\n                    height: 50px;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    background-color: #ccc;\n                    border-radius: 50%;\n                    .nc-icon{\n                        top: 0px;\n                        font-size: 18px;\n                        width: 18px;\n                    }\n                }\n                .user-details{\n                    color: rgba(2, 58, 40, 1);\n                    display: flex;\n                    flex-direction: column;\n                    h3{\n                        font-weight: 600;\n                        font-size: 18px;\n                        line-height: 26px;\n                        text-transform: capitalize;\n                        margin: 0px;\n                    }\n                    span{\n                        font-size: 16px;\n                        line-height: 22px;\n                        font-weight: 500;\n                        text-transform: capitalize;\n                    }\n                }\n            }\n            .dropdown-menu{\n                min-width: 100px;\n                transform: translate3d(0px, 35px, 0px);\n                padding: 6px;\n                border-radius: 10px;\n                .dropdown-item{\n                    padding: 6px 12px;\n                    border-radius: 10px;\n                    &:hover,\n                    &:focus{\n                        color: rgb(0, 58, 39) !important;\n                        background-color: rgba(2, 58, 40, 0.2);\n                    }\n                }\n            }\n        }\n        .logout-btn-wrap{\n            border: 0;\n            color: rgb(199, 16, 38);\n            font-size: 18px;\n            line-height: 26px;\n            padding: 8px 14px;\n            border-radius: 30px;\n            background-color: rgba(193, 10, 10, 0.15);\n            min-width: 140px;\n            min-height: 50px;\n            &:hover,\n            &:focus,\n            &:active{\n                background-color: rgba(193, 10, 10, 0.30) !important;\n                color: rgb(199, 16, 38);\n            }\n            .fa{\n                font-size: 14px;\n            }\n        }\n    }\n    @media (max-width: 1600px){\n        &.inner-main-navbar{\n            padding: 15px 25px !important;\n            .user-dropdown {\n                .nav-link{\n                    .user-icon{\n                        width: 45px;\n                        height: 45px;\n                        .nc-icon{\n                            font-size: 16px;\n                            width: 16px;\n                        }\n                    }\n                    .user-details{\n                        h3{\n                            font-size: 16px;\n                            line-height: 24px;\n                        }\n                        span{\n                            font-size: 14px;\n                            line-height: 20px;\n                        }\n                    }\n                }\n            }\n            .logout-btn-wrap{\n                font-size: 16px;\n                line-height: 24px;\n                padding: 6px 12px;\n                min-width: 125px;\n                min-height: 42px;\n            }\n        }\n        .navbar-brand{\n            width: 220px;\n        }\n    }\n    @media (max-width: 1399px){\n        &.inner-main-navbar{\n            padding: 10px 25px !important;\n            .user-dropdown {\n                .nav-link{\n                    column-gap: 10px;\n                    .user-icon{\n                        width: 36px;\n                        height: 36px;\n                        .nc-icon{\n                            font-size: 12px;\n                            width: 12px;\n                        }\n                    }\n                    .user-details{\n                        h3{\n                            font-size: 14px;\n                            line-height: 20px;\n                        }\n                        span{\n                            font-size: 12px;\n                            line-height: 16px;\n                        }\n                    }\n                }\n            }\n            .logout-btn-wrap{\n                font-size: 14px;\n                line-height: 22px;\n                padding: 4px 10px;\n                min-width: 100px;\n                min-height: 35px;\n            }\n        }\n        .navbar-brand{\n            width: 180px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
